import { CSSObject } from '@emotion/react'
import { useEffect, useState } from 'react'
import { Input } from '@opallabs/kuiper'
import { validations } from '../../Content/helpers/validations'
import { styles } from './styles'

interface Props {
  embeddedContentType: string
  onRefreshChange: (val: string) => void
  onUrlChange: (val: string) => void
  overrideStyles?: CSSObject
  url: string
}

export const PreviewInput: React.FC<Props> = ({
  embeddedContentType,
  onRefreshChange,
  onUrlChange,
  overrideStyles,
  url,
}) => {
  const [urlInput, setUrlInput] = useState(url)

  useEffect(() => {
    setUrlInput(url)
  }, [url])

  const onSubmitInput = () => {
    if (validations.urlValidation.test(urlInput)) {
      onUrlChange(urlInput)
      onRefreshChange(new Date().toString())
    }
  }

  const triggerOnKeyPress = {
    blurOnTriggered: true,
    keyCodes: [13],
    triggerFunction: onSubmitInput,
  }

  return (
    <div css={styles.getInputWrapper(overrideStyles ? overrideStyles : {})}>
      <Input
        ariaLabel={`Add ${embeddedContentType} URL or Opal Content URL`}
        type="text"
        value={urlInput}
        placeholder={`Add ${embeddedContentType} URL or Opal Content URL...`}
        onChange={(value: string) => setUrlInput(value)}
        triggerOnKeyPress={triggerOnKeyPress}
        onBlur={onSubmitInput}
        style={styles.inputText}
      />
    </div>
  )
}
